module.exports = __webpack_public_path__ + "img/duke.844e7c1c.png";